import { Component, HostListener, Inject } from '@angular/core';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-settlement-filter-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule],
  templateUrl: './settlement-filter-dialog.component.html',
  styleUrl: './settlement-filter-dialog.component.scss'
})
export class SettlementFilterDialogComponent {
  FILTERS: any = {
    timeline: 0,
    bankId: 1
  };
  filterOptions: any[] = [
    {
      title: 'Timeline',
      id: 'timeline',
    },
    {
      title: 'Bank Name',
      id: 'bankId',
    },
  ];
  selectedFilterIndex: number = 0;
  filterForm!: FormGroup;
  maxDate = new Date().toISOString().split('T')[0];
  centersList: any;
  bankList: any = [];
  selectedBank: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private bankService: SettlementServiceService,
    private dialogRef: MatDialogRef<SettlementFilterDialogComponent>
  ) { }

  ngOnInit() {
    console.log('bank statememt filter dialog', this.data)
    this.getBankDetails();
    this.centersList = JSON.parse(localStorage.getItem('center')!);
    this.FILTERS = this.data.filters ?? this.FILTERS;
    this.filterOptions = this.data.filterOptions ?? this.filterOptions;
    this.filterForm = new FormGroup({
      startDate: new FormControl(this.data?.startDate ?? null),
      endDate: new FormControl(this.data?.endDate ?? null),
    });
    this.selectedBank = [this.data?.bankId];
  }

  getBankDetails() {
    this.bankService.getAllBanks('POWERJYOTI').subscribe({
      next: (result: any) => {
        this.bankList = [{ title: 'All Bank', id: '' }];
        if (!result.error && result.data.length > 0) {
          this.bankList = [...this.bankList, ...result.data.map((data: any) => {
            return {
              ...data,
              title: data.bankName,
              id: data.sbamId,
            };
          })];
        }
      },
      error: (error: any) => {
        console.log(error);
      }
    })
  }


  closeDialog() {
    this.dialogRef.close();
  }

  applyFilter() {
    let data: any = {
      startDate: this.filterForm.get('startDate')?.value ?? '',
      endDate: this.filterForm.get('endDate')?.value ?? '',
      bankId: this.selectedBank[0] ?? ''
    };
    this.dialogRef.close(data);
  }

  clearForm() {
    this.filterForm.reset();
    this.selectedBank = [''];
  }

  selectFilterItem(i: number) {
    this.selectedFilterIndex = i;
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;
    const isShift = event.shiftKey;
    const isAlt = event.altKey;
    const isEnter = event.key === 'Enter';
    const isEscape = event.key === 'Escape';

    if (isShift && isEscape) {
      event.preventDefault();
      this.clearForm();
    } else if (isCtrlOrCmd && isEnter) {
      event.preventDefault();
      this.applyFilter();
    }
  }

  onCheckBank(event: Event) {
    const input = event.target as HTMLInputElement;
    const bankId = this.bankList.filter((bank: any) => bank.bankName == input.value)[0]?.id ?? ''
    const index = this.selectedBank.indexOf(bankId);
    index === -1 ? this.selectedBank = [bankId] : this.selectedBank.splice(index, 1);
  }
}
